<div class="asset-history-container" *transloco="let t; prefix: 'compliance.library.assetHistory'">
  <div class="header">
    <div class="title-row">
      <button
        class="back-btn"
        type="button"
        [routerLink]="['/asset-management/compliance-library/compliance-details']"
        [queryParams]="{
          complianceId: complianceId,
          complianceName: complianceName,
          complianceType: complianceType,
          tab: 'assignedAssets'
        }"
        [attr.aria-label]="t('backToDetails')">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
            fill="#9FA1A4" />
        </svg>
      </button>
      <h2 class="title m-0 h3">{{ t('title', { asset: assetName }) }}</h2>
    </div>
  </div>

  <app-compliance-tasks
    [columns]="columns"
    [data]="historyRows"
    [isLoading]="isLoading"
    [isLoadingMore]="isLoadingMore"
    [hasError]="hasError"
    [isComplianceTasks]="true"
    [isAssetHistory]="true"
    (rowClicked)="onRowClick($event)"
    (scrolledDown)="onScrollDown()">
  </app-compliance-tasks>
</div>